import { render } from "./CreateGoals.vue?vue&type=template&id=8311567e&scoped=true&ts=true"
import script from "./CreateGoals.vue?vue&type=script&lang=ts"
export * from "./CreateGoals.vue?vue&type=script&lang=ts"

import "./CreateGoals.vue?vue&type=style&index=0&id=8311567e&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src4026252432/src/luca_web/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8311567e"]])

export default __exports__